import { isEmpty } from 'es-toolkit/compat';

import { getJob } from 'api/jobs';
import { Job } from 'interfaces/job';
import { useQueryWithErrorAndRetrySnackbar } from 'utils/useQueryWithErrorAndRetrySnackbar';

export const jobQueryKey = 'job';

export const getJobQueryKey = (jobId: string) => [jobQueryKey, jobId] as const;

export const getJobQuery = <JobType extends Job = Job>(jobId: string) => ({
  queryKey: getJobQueryKey(jobId),
  queryFn: ({ signal }: { signal?: AbortSignal }) => getJob<JobType>(jobId, signal),
});

export const useJob = <JobType extends Job = Job>(
  jobId: string,
  options?: Parameters<typeof useQueryWithErrorAndRetrySnackbar<JobType>>[2]
) => {
  const enabled = !isEmpty(jobId) && (options?.enabled ?? true);

  return useQueryWithErrorAndRetrySnackbar<JobType>(
    getJobQueryKey(jobId),
    ({ signal }) => getJob<JobType>(jobId, signal),
    {
      retry: false,
      queriedEntityName: 'job',
      consoleOnly: true,
      ...options,
      enabled,
    }
  );
};
